import { upperFirst, camelCase } from 'lodash-es';

// TODO: Integrate with angular-common's breakpoint defs.
export const BREAKPOINTS = {
  xs: 768,
  sm: 992,
  md: 1200,
};

export const QUERIES = {
  xs: `(max-width: ${BREAKPOINTS['xs'] - 1}px)`,
  'gt-xs': `(min-width: ${BREAKPOINTS['xs']}px)`,
  sm: `(min-width: ${BREAKPOINTS['xs']}) and (max-width: ${BREAKPOINTS['sm'] -
    1}px)`,
  'gt-sm': `(min-width: ${BREAKPOINTS['sm']}px)`,
  md: `(min-width: ${BREAKPOINTS['sm']}) and (max-width: ${BREAKPOINTS['md'] -
    1}px)`,
  'lt-md': `(max-width: ${BREAKPOINTS['sm'] - 1}px)`,
  'gt-md': `(min-width: ${BREAKPOINTS['md']}px)`,
  'lt-lg': `(max-width: ${BREAKPOINTS['md'] - 1}px)`,
  lg: `(min-width: ${BREAKPOINTS['md']}px)`,
};

export const matchMediaDirectiveName = (prefix, query) =>
  prefix + upperFirst(camelCase(query));
